__turbopack_context__.v({
  "paypalBnplMessage": "PayPalBnplMessage-module-scss-module__B9a3da__paypalBnplMessage",
});
